import Responsive from './Responsive';
import SmoothScroll from './SmoothScroll';
import SpNavi from './SpNavi';
import ToTop from './ToTop';
import Gmap from './Gmap';
import bowser from 'bowser'
import remodal from 'remodal'
import FixedSidenav from './FixedSidenav';
import changeNavCurrent from './changeNavCurrent';

if(bowser.msie === true) {
  $('body').addClass('ie');
}else if(bowser.msedge === true){
  $('body').addClass('edge');
}else if(bowser.firefox === true){
  $('body').addClass('ff');
}else if(bowser.tablet === true){
  $('body').addClass('tablet');
}
if(bowser.mobile === true){
  $('body').addClass('device--mobile');
  if(bowser.android === true) {
    $('body').addClass('device--mobile--android');
  }
}

let os, ua = navigator.userAgent;
if (ua.match(/Win(dows )?NT 10\.0/)) {
  os = "win10";
}
else if (ua.match(/Win(dows )?NT 6\.3/)) {
  os = "win8_1";
}
else if (ua.match(/Win(dows )?NT 6\.2/)) {
  os = "win8";
}
else if (ua.match(/Win(dows )?NT 6\.1/)) {
  os = "win7";
}else{
  os = '';
}

$('body').addClass(os);
/* ===============================================
Check responsive state
=============================================== */
// const r = new Responsive();

// $(window).on('resize',function(){
// check is responsive;
// 	console.log(r.state()());
// });
// check is mobile;
// alert(r.isPhone());
/* ===============================================
SP Navi
=============================================== */
const nav_clone = $('.gnav').clone();
$('#scroller').append(nav_clone.find('ul'));
let param = {
	target:'#spnavi',
	trigger:'.btn_sp_navi',
	filter:'resposive_flg',
	speed:200
};
const spnavi = new SpNavi(param);
spnavi.exec();
/* ===============================================
Smooth Scroll
=============================================== */
const sms = new SmoothScroll();
sms.exec();
/* ===============================================
To Top
show/hide toggle
=============================================== */
const totop = new ToTop('#totop',100,400);
totop.exec();
/* gmap
----------------------- */
if($('#access_map').length > 0){
	$(window).on('load',function(){
		let gmap = new Gmap(
				'access_map',
				[{"stylers": [{"hue": "#84c8ff"},{"lightness": 22}],"elementType": "all","featureType": "all"}],
				{lat:35.001020, lng:135.888012},
				{lat:35.002422, lng:135.889880},
				{zoom:16,icon:MAPPIN,title:'map'}
			);
		gmap.exec();
	});
}

(function($) {
$(function(){
	//Pdf
	$('.js--link_icon[href$=pdf]').addClass('js--link_icon-pdf').attr({target:"_blank"});
	//Excel
	$('.js--link_icon[href$=xls],.js--link_icon[href$=xlsx],.js--link_icon[href$=xlsm]').addClass('js--link_icon-xls').attr({target:"_blank"});
	//Word
	$('.js--link_icon[href$=doc],.js--link_icon[href$=docx]').addClass('js--link_icon-docx').attr({target:"_blank"});
	//PowerPoint
	$('.js--link_icon[href$=pptx],.js--link_icon[href$=pptm],.js--link_icon[href$=ppt]').addClass('js--link_icon-pptx').attr({target:"_blank"});
	//外部リンク
	$('.js--link_icon[href^=http]:not([href*="'+location.hostname+'"],[href$=pdf],[href$=xls],[href$=xlsx],[href$=xlsm],[href$=doc],[href$=docx],[href$=pptx],[href$=pptm],[href$=ppt])').addClass('js--link_icon-ext').attr({target:"_blank"});
});
})(jQuery);


(function($) {
$(function(){
	$('.list li').each(function(){
		let txt = $(this).html();
		txt = txt.replace(/Masaru IHARA/g,'<u>Masaru IHARA</u>');
		txt = txt.replace(/Masaru Ihara/g,'<u>Masaru Ihara</u>');
		txt = txt.replace(/井原賢/g,'<u>井原賢</u>')
		$(this).html(txt);
	});
});
})(jQuery);

$(window).on('load',function(){
	let my_remodal = require('./my_remodal');
	my_remodal();

	const fixednav = new FixedSidenav(0,$('.js-fixed_sidemenu').length);
	fixednav.exec();

	const change_nav_current = new changeNavCurrent();
	change_nav_current.exec();
});



// WEBPACK FOOTER //
// ./dev/js/scripts/main.js